import styled from 'styled-components';
import { PostBox } from './Home.style';

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: ${(props) => props?.customcss};
  .about-info {
    display: flex;
  }
`;

const CustomisePopoverStyle = styled.div`
  .emoji-icon {
    cursor: pointer;
    padding: 3px;
    width: 21px;
    height: 21px;
    border-radius: 100%;
    svg {
      width: 21px;
      height: 21px;
      path {
        fill: ${({ theme }) => theme.gray[1]};
      }
    }
    &:hover {
      background: #ebebeb;
    }
  }
  .emoji-popover {
    background: #fff;
    position: absolute;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    z-index: 1;
  }
  button {
    display: block;
  }
`;

const Profile = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors[2]};
  div div svg {
    width: 40px;
    height: 40px;
    border: 1px solid;
    border-radius: 50px;
    padding: 5px;
    background: #ffffff;
  }
`;

const IconViews = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  width: fit-content;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 8px;
`;

const SubmitContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  padding: 0 24px 5px 24px;
  border: 1px solid #ebebeb;
  .icon-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 30%;
  }
`;

const UploadContainer = styled.div`
  overflow: auto;
  padding: 24px 24px 24px 24px;
`;

const SubmitPost = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  .back-btn {
    background: white;
    border: 1px solid #f3f2ee;
    margin-right: 1rem;
  }
`;

const ImageContainer = styled.div`
  .imgUploadContainer {
    display: flex;
    gap: 1.5%;
    flex-wrap: wrap;
    height: auto;
    overflow: auto;
    width: 100%;

    .upload-images {
      width: 48.5%;
      height: 280px;
      margin-bottom: 2%;
      position: relative;
      border-radius: 5px;
      border: 1px solid ${({ theme }) => theme.border1};
      box-shadow: ${({ theme }) => theme.boxShadow1};
    }
    .imageItems {
      height: 280px;
      border-radius: 5px;
      object-fit: cover;
    }
    .ant-image {
      width: 100%;
    }
    .ant-image-mask {
      border-radius: 5px;
    }
  }
`;

const PostInfoContainer = styled.div`
  .user-block {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }
  .user-profile {
    width: 40px;
    height: 40px;
    margin-right: 10px;
    border-radius: 50%;
    object-fit: contain;
  }
  .username-block {
    width: 50%;
    white-space: nowrap;
    margin-left: 8px;
  }
  .user-displayname {
    font-weight: 500;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${({ theme }) => theme.text1};
  }
  .user-name {
    font-size: 13px;
    color: #828282;
    overflow: hidden;
    text-overflow: ellipsis;
    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
  .spinner {
    text-align: center;
  }
  .imageCloseIcon {
    position: absolute;
    right: 5px;
    top: 5px;
    z-index: 1;
  }
  .imageEditIcon {
    position: absolute;
    top: 5px;
    right: 60px;
    cursor: pointer;
    z-index: 1;
  }
  .btnWidth {
    width: 100%;
  }
  .comment-container-flex {
    display: flex;
  }
  .comment-container {
    width: 30%;
    background-color: ${({ theme }) => theme.lightGray};
    padding: 0px !important;
    margin-bottom: 6px;
    margin-right: 6px;
    border-radius: 4px;
    .MuiInputBase-root:not(.MuiInputBase-multiline) {
      height: 30px !important;
      border: none;
    }
    .MuiInputBase-input {
      padding: 4px 8px !important;
      color: ${({ theme }) => theme.text1};
      &:hover {
        background-color: ${({ theme }) =>
          theme.lightGrayHover};
      }
    }
    svg {
      fill: ${({ theme }) => theme.text1};
    }
  }
  .MuiOutlinedInput-notchedOutline {
    border: none;
  }
  .home-text-editor {
    .ql-toolbar {
      border-radius: 5px;
    }
    .ql-container.ql-snow {
      border: none;
      border-radius: 5px;
      background-color: ${({ theme }) => theme.mode === "light" ? '#f5f5f5' : '#282828'};
      margin-top: 4px;
    }
  }
`;

const DocContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 100%;
  // min-height: 615px;
  border: ${({ isscroll }) => (isscroll ? '0' : '1px')}; solid ${({ theme }) => theme.colors[5]};
  border-radius: 4px;
  margin: ${({ readonly }) => (!readonly ? '0 auto' : '20px auto 0')};

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  > div:first-child {
    width: 100%
  }

  .react-pdf__Page {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media only screen and (max-width: 500px) {
    // min-height: 450px;
  }
  .react-pdf__Page {
    border-radius: 4px;
  }
  .react-pdf__Page__canvas {
    max-width: 100%;
    height: auto !important;
    border-radius: 4px;
  }
  .react-pdf__Page__textContent,
  .annotationLayer {
    display: none;
  }
  .react-pdf__message {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
  }
  .docCloseIcon {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 1;
  }
  button {
    border-radius: 50%;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
  }
  .document-backbtn {
    position: absolute;
    top: 40%;
    left: 5px;
    z-index: 1;
  }
  .document-backbtn,
  .document-nextbtn {
    padding: 2px;
    background-color: ${({ theme }) => theme.mode === 'light' ? '#f7f7f7' : theme.lightGrayHover};
    transition: opacity 0.5s;
    opacity: 0.1;
    svg {
      width: 40px;
      height: 40px;
      fill: ${({ theme }) => theme.svg1};
    }
  }
  &:hover {
    .document-backbtn,
    .document-nextbtn {
      opacity: 1;
    }
    .page-number-doc {
      opacity: 1;
    }
  }
  .document-nextbtn {
    position: absolute;
    top: 40%;
    right: 5px;
  }
  .page-number-doc {
    position: absolute;
    bottom: 10px;
    left: 0px;
    width: 94%;
    margin-left: 3%;
    background-color: ${({ theme }) => theme.mode === 'light' ? '#f7f7f7' : theme.lightGrayHover};
    border: 1px solid ${({ theme }) => theme.border1};
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    font-weight: 600;
    transition: opacity 1s;
    opacity: 0;
    border-radius: 8px;
    box-sizing: border-box;
    border-radius: 50px;
    .MuiSlider-root {
      width: 96%;
    }
  }
  .scroll-download {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 10;
    width: 24px;
    height: 24px;
    cursor: pointer;
    fill: ${({ theme }) => theme.svg1};
    &:hover {
      fill: #1976d2;
    }
  }
  .doc-action {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
    padding: 0 16px;
    border-radius: 50px;
    color: ${({ theme }) => theme.svg1};
    svg {
      cursor: pointer;
      width: 24px;
      height: 24px;
      fill: ${({ theme }) => theme.svg1};
      &:hover {
        fill: #1976d2;
      }
    }
  }
  .pdf-page-wrapper {
    margin: 2px 2px 16px;
    box-shadow: ${({ theme }) => theme.boxShadow1};
    border-radius: 8px;
    max-width: 800px;
  }
  .slick-dots {
    display: none !important;
  }
  .slick-slide > div > div {
    border-radius: 10px;
  }
  .slider-container {
    display: flex;
    justify-content: center;
    width: 80%;
  }
`;

const VideoContainer = styled.div`
  position: relative;
  margin-top: 4px;
  // video {
  //   border-radius: 5px;
  //   border: 1px solid ${({ theme }) => theme.border1};
  //   box-shadow: ${({ theme }) => theme.boxShadow1};
  // }
  .postVideo {
    width: 100%;
    height: 300px;
  }
  .videoCloseIcon {
    position: absolute;
    right: 7px;
    top: 24px;
  }
`;

// CommentContainer
const CommentContainer = styled.div`
  padding: ${(isDetailPage) => (isDetailPage ? 0 : '20px')};
  .detail-single-post {
    margin-bottom: 20px;
    @media only screen and (max-width: 599px) {
      >div>div:first-child {
        width: 91vw;
      }
    }
  }
  .actionText {
    padding: 5px 12px;
    font-size: 12px;
    border-radius: 50px;
    cursor: pointer;
    font-weight: 600;
    color: #2d90ff;
    position: relative;
    bottom: 2px;
    &:hover {
      background: #ebebeb;
    }
  }
`;

const CommentInputBox = styled.div`
  display: flex;
  padding: ${({ type }) =>
    type === 'childreply' ? '0 0 8px 0' : type === 'nestedchild' && '0'};
  .profile-pic {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  .InputContainerStyle {
    width: 100%;
    padding-left: 8px;
  }
  .comment-submit-action {
    display: flex;
    > div {
      margin: 3px 3px 0;
    }
  }
  .postBtn {
    border-radius: 50px;
  }

  .reply-action {
    display: flex;
    > div {
      margin: 3px 3px 0;
    }
    @media only screen and (max-width: 500px) {
      > div {
        display: none;
      }
      button {
        margin-left: 6px;
      }
    }
  }
`;

const CommentUserDetails = styled.div`
  display: flex;
  width: 100%;
  .user-name {
    font-size: 13px;
    font-weight: 400;
    color: #828282;
  }
  .post-time {
    font-size: 13px;
    color: #828282;
    white-space: nowrap;
  }
  .profile-pic {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: contain;
  }
  .comment-profile {
    position: relative;
    margin-right: 8px;
    > div:nth-child(2) {
      display: inline-block;
      border-left: 1px solid ${({ theme }) => theme.border1};
      position: absolute;
      height: calc(100% - 50px);
      left: 47%;
      top: 45px;
    }
  }
  .reply-comment-container, .reply-userinfo-container {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
  }
  .reply-comment-userinfo, .reply-userinfo {
    display: flex;
    .user-name {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
  .remove-icon {
    position: relative;
    bottom: 1.5px;
    > button {
      fill: red;
    }
  }
`;

const CommentBox = styled.div`
  padding: 8px 8px 0;
  .cmt-more {
    padding-left: 60px;
    color: ${({ theme }) => theme.colors[4]};
    cursor: pointer;
  }
  .comment-text {
    font-size: 15px;
    white-space: normal;
  }
  .userReplyComment {
    display: flex;
    margin: 8px 0;
    margin-left: 50px;
  }
  .commentCardContainer {
    margin-left: 8px;
    width: 100%;
  }
  .commentCard {
    width: 100%;
    background: ${(props) => props.theme.fieldBG};
    padding: 0px;
    border-radius: 10px;
    font-size: 11px;
    color: ${({ theme }) => theme.colors[2]};
  }
  .userNameView {
    color: #333;
    font-weight: 700;
    cursor: pointer;
    font-size: 12px;
    &:hover {
      color: #0b65c2;
    }
  }
  .userName {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 20px;
    > div {
      color: ${({ theme }) => theme.colors[2]};
    }
  }
  .commentAction {
    display: flex;
    align-items: center;
  }
  .likeIcon {
    padding: 0 3px 0 0px;
    font-size: 15px;
    display: flex;
    div svg {
      fill: #5f6368;
      cursor: pointer;
      width: 20px;
      height: 20px;
      padding: 5px 3px;
      border-radius: 50%;
      margin-left: 3px;
      &:hover {
        background: #ebebeb;
      }
    }
  }
  .actions-like {
    display: flex;
    font-size: 13px;
    color: #606060 !important;
    > span {
      display: flex;
      align-items: center;

      &:first-child {
        padding-right: 5px;
      }
    }
  }

  .actionBorder {
    border-right: 1px solid #e0dfdc;
    padding-right: 10px;
  }
  .actionContainer {
    margin-top: 5px;
    display: flex;
    align-items: center;
  }
  .reactionContainer {
    width: 250px;
  }
  .allOption {
    padding-right: 10px;
  }
  .reactionHeader {
    display: flex;
    border-bottom: 1px solid #e0dfdc;
    padding: 15px;
    color: #333;
  }
  .pro_image {
    height: 50px;
    width: 50px;
    border-radius: 25px;
    margin-right: 15px;
  }
  .emojInfo {
    display: flex;
    justify-content: space-between;
    padding: 15px;
    align-items: center;
  }
  .userEmojiinfo {
    display: flex;
    align-items: center;
    color: #333;
  }
  .userfirst_name {
    font-size: 16px;
    font-weight: 500;
  }
  .emojiPopup {
    position: absolute;
  }
  .emptyEmoj {
    padding: 15px;
    text-align: center;
  }
  .remove {
    cursor: pointer;
  }
  .dislikecmt {
    padding-left: 10px;
  }
  .reply-cnt {
    font-size: 14px;
    margin-bottom: 8px;
    color: ${({ theme }) => theme.colors[4]};
    cursor: pointer;
    width: fit-content;
    &:hover {
      text-decoration: underline;
    }
    .anticon {
      padding-right: 4px;
    }
  }

  .comment-container {
    margin-top: 5px;
    margin-right: 20px;
  }
  .updt-time {
    font-size: 12px;
    color: #606060;
    font-weight: 400;
  }
  .no-comment {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 0 80px 0;
    color: #828282;
    font-size: 15px;
  }
`;

const ShareStyle = styled.div`
  .share-div {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
    li {
      padding: 4px;
      font-size: 15px;
      border-radius: 4px;
      width: 90px;
      height: 70px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    svg {
      width: 35px;
      height: 35px;
      margin-bottom: 4px;
    }
  }
  .copy-container {
    position: relative;
    width: 100%;
    > div {
      display: flex;
      align-items: center;
      font-size: 15px;
      border-radius: 50px;
      height: 44px;
      background-color: ${({ theme }) => theme.lightGrayHover};
      margin-top: 16px;
      padding-left: 14px;
    }
    #copy-text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: calc(100% - 120px);
    }
    > button {
      width: 100px;
      position: absolute;
      top: 4px;
      right: 8px;
      display: flex;
      align-items: center;
    }
  }
`;

const SuggestionsStyle = styled.div`
  .suggestion-fol-btn {
    height: 32px;
  }
  .user-headline {
    padding: 2px 4px 0px;
    font-size: 14px;
    color: ${({ theme }) => (theme.mode === 'light' ? '#3d3d3d' : '#bbbbbb')};
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  ${PostBox} {
    margin: 8px 0;
    padding: 8px 4px;
  }
`;

export {
  UserInfo,
  Profile,
  IconViews,
  SubmitContainer,
  UploadContainer,
  SubmitPost,
  ImageContainer,
  PostInfoContainer,
  VideoContainer,
  CommentContainer,
  CommentInputBox,
  CommentUserDetails,
  CommentBox,
  DocContainer,
  ShareStyle,
  SuggestionsStyle,
  CustomisePopoverStyle,
};
